import {defineStore} from 'pinia'
import {http} from '@/extensions/http'
import API_ENDPOINTS from '@/config/API_ENDPOINTS.ts'
import i18n from '@/i18n'

export const useDocumentStore = defineStore('document', {
    state: () => ({
        memory: {
            index: {
                en: [],
                fr: []
            } as Record<locale, Document[]>
        }
    }),
    actions: {
        async all() {
            const locale: locale = i18n.global.locale.value

            if (this.memory.index[locale]?.length) return this.memory.index[locale]

            const {data} = await http.get<Document[]>(API_ENDPOINTS.DOCUMENT.INDEX.replace(':chair', import.meta.env.VITE_APP_CHAIR_ID))

            this.memory.index[locale] = data

            return data
        }
    }
})